export const MISSION_KEYS = {
  STATUS: 'missions',
} as const
